
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1mabk_4ucmx_93",
  "radio": "awsui_radio_1mabk_4ucmx_129",
  "radio--has-description": "awsui_radio--has-description_1mabk_4ucmx_137",
  "radio-control": "awsui_radio-control_1mabk_4ucmx_141",
  "outline": "awsui_outline_1mabk_4ucmx_149",
  "styled-circle-border": "awsui_styled-circle-border_1mabk_4ucmx_168",
  "styled-circle-disabled": "awsui_styled-circle-disabled_1mabk_4ucmx_172",
  "styled-circle-fill": "awsui_styled-circle-fill_1mabk_4ucmx_177",
  "styled-circle-checked": "awsui_styled-circle-checked_1mabk_4ucmx_183"
};
  